/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */

export type BboBranchConfigPouchTypePouchType =
  (typeof BboBranchConfigPouchTypePouchType)[keyof typeof BboBranchConfigPouchTypePouchType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BboBranchConfigPouchTypePouchType = {
  Cash: 'Cash',
  Stock: 'Stock',
  Forex: 'Forex',
} as const;
